import type { FC, ReactNode } from 'react';
import type { TextProps } from 'react-native-paper';
import { Text } from 'react-native-paper';

import { Row } from '@/shared/components/layout/Row';
import { useAppTheme } from '@/styles/hooks/useAppTheme';
import type { SVGComponent } from '@/types';

type TitleProps = {
  children: ReactNode;
  color?: string;
  font?: string;
  variant?: TextProps<string>['variant'];
  icon?: SVGComponent;
  iconColor?: string;
};

export const Title: FC<TitleProps> = ({
  children,
  color,
  font,
  variant = 'titleMedium',
  icon,
  iconColor
}) => {
  const theme = useAppTheme();

  return (
    <Row style={{ flex: 1, gap: 4, alignItems: 'center' }}>
      {icon?.({
        fill: color ?? iconColor ?? theme.colors.error,
        width: 32,
        height: 32
      })}
      <Text
        variant={variant}
        style={{ color: color ?? theme.colors.onSurface, fontFamily: font }}
        ellipsizeMode="tail"
        numberOfLines={1}
      >
        {children}
      </Text>
    </Row>
  );
};
